// see: https://github.com/prettier/prettier/blob/master/src/language-js/loc.js
function getRange(index, node) {
  if (node.range) {
    return node.range[index];
  }

  if (node.expression.range) {
    return node.expression.range[index];
  }

  return null;
}

module.exports = {
  locEnd: function locEnd(node) {
    return getRange(1, node);
  },
  locStart: function locStart(node) {
    return getRange(0, node);
  }
};